import React, { useEffect, useState } from "react";
import UnpublishedNoticeLogo from "./UnpublishedNoticeLogo";
import { getBrand } from "../../New/serverRequests/requests";

const UnpublishedNotice = ({ whiteLabelInfo, author }) => {
    const [brandData, setBrandData] = useState([]);

    const callBrand = () => {
        if (author === undefined) return;
        getBrand(author).then((data) => {
            setBrandData(data[0]);
        })
    }

    useEffect(() => callBrand(), [author]);

    return (
        <div className='notice'>
            <img className="WarningUnpublisedReload" src="/static/public/img/Redo_Button.png"
                onClick={() => window.location.reload(false)} />
            <img className="WarningUnpublished" width="15%" src="/static/public/img/warning-unpublished.png" style={{ maxWidth: 'unset', minWidth: '120px'}}/>

            <h2 className="sorryH2" style={{ color: '#000000', marginTop: '6px', fontSize: 'x-large' }}>Sorry!</h2>
            <div>
                <p>This interactive virtual property tour is not available at this time.</p>
                <p>The tour may be offline temporarily because it is being updated</p>
                <p style={{ marginTop: '-2%' }}>or permanently offline because it has been deleted.</p>
                <p className='last'>If the property is still on the market, please check again in a few minutes.</p>
            </div>

            <UnpublishedNoticeLogo whiteLabelInfo={whiteLabelInfo} brandData={brandData} />
        </div>
    )
}

export default UnpublishedNotice;
